import Vue from 'vue';
import Promise from 'promise';
import Store from '../store/store';
import Http from './http';
import utils from './utils';
import router from '../router';
import sensorsdata from 'sa-sdk-javascript';

function User() {
  this.token = null;
  this.peer = {};
  this.isSignOut = false;
}

let vm;

User.prototype.loaded = new Promise(((resolve, reject) => {
  User.prototype.resolve = resolve;
  User.prototype.reject = reject;
}));

window.localStorage || (window.localStorage = {});
window.sessionStorage || (window.sessionStorage = {});

User.prototype.isLogin = function () {
  return this.token && this.peer_account_id;
};

// // 部分内容存在两者都需要显示的
// User.prototype.isAdminOrFinance = function () {
//   return this.isAdmin() || this.isFinance();
// };

User.prototype.isAdminRole = function () {
  return this.role_id === 0;
};

User.prototype.isFinanceRole = function () {
  return this.role_id === 2;
};

User.prototype.isOperatorRole = function () {
  return this.role_id === 1;
};

User.prototype.save = function (data, save) {
  const storage = save ? localStorage : localStorage;


  console.log(storage.token);
  if (storage.token !== data.token) {
    // 旧token
    storage.login_time = new Date().getTime();

    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    storage.token = data.token;
  }


  if (data.peer_account_id !== undefined) {
    storage.userId = data.peer_account_id;
  }
  if (data.visa_peer_id !== undefined) {
    localStorage.visaPeerId = data.visa_peer_id;
  }
  if (data.is_palmyou !== undefined) {
    storage.is_palmyou = data.is_palmyou;
  }
  if (data.is_first_login !== undefined) {
    storage.is_first_login = data.is_first_login;
  }
  if (data.is_update_phone !== undefined) {
    storage.is_update_phone = data.is_update_phone;
  }
};

User.prototype.login = function (data, save) {
  Object.keys(data).forEach((k) => {
    Vue.set(this, k, data[k]);
  });

  const keep = data.is_palmyou ? 1 : save;

  this.save(data, keep);

  const userInfo = Object.assign({}, Store.state.user.userInfo, data);

  Store.commit('user/SET_USER_INFO', userInfo);

  window.ga && ga('set', 'userId', data.peer_account_id);
};

User.prototype.logout = function (stay) {
  Object.keys(this).forEach((k) => {
    typeof this[k] !== 'object' && Vue.delete(this, k);
  });

  // Object.keys(this.peer).forEach((k) => {
  //   Vue.delete(this.peer, k);
  // });
  this.peer = {};

  sessionStorage.removeItem('token');
  localStorage.removeItem('token');

  !stay && this.getOut();

  User.prototype.refresh();
};

User.prototype.getOut = function () {
  if (vm.$route.matched.some(path => path.meta.needAdmin || path.meta.needLogin)) {
    vm.$router.replace({ path: '/' });
  }
};

User.prototype.init = function () {
  let token;
  let login_time;
  let userId;
  let visaPeerId;
  let is_palmyou;
  let is_first_login;
  let is_update_phone;

  sessionStorage.token && sessionStorage.token !== 'undefined' && (token = sessionStorage.token);
  sessionStorage.login_time && sessionStorage.login_time !== 'undefined' && (login_time = sessionStorage.login_time);
  sessionStorage.userId && sessionStorage.userId !== 'undefined' && (userId = sessionStorage.userId);

  localStorage.token && localStorage.token !== 'undefined' && (token = localStorage.token);
  localStorage.login_time && localStorage.login_time !== 'undefined' && (login_time = localStorage.login_time);
  localStorage.userId && localStorage.userId !== 'undefined' && (userId = localStorage.userId);
  localStorage.visaPeerId && localStorage.visaPeerId !== 'undefined' && (visaPeerId = localStorage.visaPeerId);
  localStorage.is_palmyou && localStorage.is_palmyou !== 'undefined' && (is_palmyou = localStorage.is_palmyou);
  localStorage.is_first_login && localStorage.is_first_login !== 'undefined' && (is_first_login = localStorage.is_first_login);
  localStorage.is_update_phone && localStorage.is_update_phone !== 'undefined' && (is_update_phone = localStorage.is_update_phone);

  // token7天失效， 七天后就不用了
  const nowTime = new Date().getTime();
  if (token && (login_time && (nowTime - +login_time) < 7 * 24 * 60 * 60 * 1000)) {
    this.login({
      token,
      peer_account_id: +userId,
      visa_peer_id: +visaPeerId,
      is_palmyou: is_palmyou && +is_palmyou,
      is_first_login: is_first_login && +is_first_login,
      is_update_phone: is_update_phone && +is_update_phone,
    });
  } else {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    sessionStorage.removeItem('login_time');
    localStorage.removeItem('login_time');
  }
};

let initUserDetailPromise = null;
// 初始化详情是否结束
User.prototype.initUserDetail = function () {
  if (!this.isLogin()) {
    Store.commit('followOA/IS_LOGIN', { isLogin: 0 });
    return Promise.resolve();
  }
  // 已经初始化过了，直接结束
  if (this.peer && Object.keys(this.peer) > 0) {
    return Promise.resolve();
  }
  if (initUserDetailPromise) return initUserDetailPromise;
  initUserDetailPromise = new Promise(async (resolve) => {
    try {
      if (!this.isLogin()) {
        initUserDetailPromise = null;
        resolve();
        return;
      }
      const accountInfo = await Http.post('/peer_account_query', {}, { noToast: true });
      this.login(utils.extend({}, accountInfo, { token: this.token, is_palmyou: this.is_palmyou }), +localStorage.getItem('remember'));
      Store.commit('followOA/SAVE_MP_WATCH', { mp_watch: this.mp_watch });
      Store.commit('followOA/INIT_QRCODE_STA', { currentRouteName: router.currentRoute.name });
      Store.commit('followOA/IS_LOGIN', { isLogin: 1 });
      const peerInfo = await Http.post('/visa_peer_query');
      this.peer = peerInfo;
      Store.commit('user/SET_PEER_DATA', peerInfo);
      sensorsdata.track('login', {
        login_source: '系统自动登陆',
        peer_name: peerInfo.peer_name,
      });
      sensorsdata.login(peerInfo.visa_peer_id);
      this.resolve(this);
    } catch (error) {
      console.log(error);
    }
    initUserDetailPromise = null;
    resolve();
  });
  return initUserDetailPromise;
  
};

User.prototype.refresh = function () {
  User.prototype.loaded = new Promise(((resolve, reject) => {
    User.prototype.resolve = resolve;
    User.prototype.reject = reject;
  }));
};

User.prototype.inject = function (vueModel) {
  vm = vueModel;
};

User.prototype.refresh();

export default new User();



// WEBPACK FOOTER //
// ./src/libs/user.js